<template>
  <el-card class="box-card" ref="card">
    <h3>{{ year }}年红人年度品牌合作Top10</h3>
    <el-table class="dashboard-table"
              show-summary
              :summary-method="getSummaries"
              :row-class-name="rowClassName"
              :data="dataTable"
              style="width: 100%">
      <el-table-column prop="index" label="排名" align="center"/>
      <el-table-column prop="brand_name" label="品牌" align="center">
        <template v-slot="{row:{brand_name}}">
          <span @click="handelToBrand(brand_name)" style="cursor: pointer;">{{ brand_name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_money" label="订单金额（元）" align="center">
        <template slot-scope="scope">
          <span class="money">{{ gFunc.numberFormat(scope.row.order_money) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="order_count" label="订单量（单）" align="center"/>
    </el-table>
  </el-card>
</template>

<script>
import {artistBrand} from "@/api/dashboard";

export default {
  name: "ArtistBrand",
  props: {
    year: [Number, String],
    artistId: [String],
    organizationId: {
      type: [Number, String],
      default: 'ALL'
    },
  },
  data() {
    return {
      queryYear: this.year,
      dataTable: [],
    }
  },
  created() {
    this.getData()
  },
  watch: {
    year: function (value) {
      this.queryYear = value;
      this.getData()
    },
  },
  methods: {
    handelToBrand(brand) {
      const {year, organization_id} = this.$route.query
      const {href} = this.$router.resolve({
        name: `homeBrandDetail`,
        query: {brandName: brand, year, organization_id}
      });
      window.open(href, "_blank");
    },
    getData() {
      this.data = [];
      artistBrand({
        year: this.queryYear, artist_id: this.artistId,
        organization_id: this.organizationId,
      }).then(res => {
        this.dataTable = res.model.data;
      })
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        if (['order_money', 'order_count'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "order_money":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index]);
              break;
            case "order_percent_money":
            case "order_percent_count":
              sums[index] = this.gFunc.numberFormat(sums[index]) + "%";
              break;
          }
        }
      });
      return sums
    },
  }
}
</script>

<style>

</style>
